'use strict';

import globalize from './internal/globalize';

var keyCode = {
    ALT: 18,
    BACKSPACE: 8,
    CAPS_LOCK: 20,
    COMMA: 188,
    COMMAND: 91,

    // cmd
    COMMAND_LEFT: 91,
    COMMAND_RIGHT: 93,
    LEFT_SQUARE_BRACKET: 91, //This is 91 for keypress and 219 for keydown/keyup
    CONTROL: 17,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    INSERT: 45,
    LEFT: 37,

    // right cmd
    MENU: 93,
    NUMPAD_ADD: 107,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    NUMPAD_ENTER: 108,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_SUBTRACT: 109,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SHIFT: 16,
    SPACE: 32,
    TAB: 9,
    UP: 38,

    // cmd
    WINDOWS: 91
};

globalize('keyCode', keyCode);

export default keyCode;
